import { useState } from 'react'

import { Box, Button, InputCheckBox, Text } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { AtsCandidatesTalentPoolConfirmationModalDocument } from 'generated/resources/graphql'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import Modal from 'modules/core/components/Modal'
import { useQuery } from 'modules/core/hooks/useQuery'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'
import i18n from 'modules/core/lib/i18n'

import { useUpdateTalentPool } from 'modules/ats/lib/utils/useUpdateTalentPool'

interface Props {
  onClose: () => void
  candidateId: string
}

export const TalentPoolConfirmationModal = ({ onClose, candidateId }: Props) => {
  const [rememberConfirmation, setRememberConfirmation] = useState(false)

  const { data: candidate } = useQuery(AtsCandidatesTalentPoolConfirmationModalDocument, {
    variables: { id: candidateId },
  })

  const talentPool = candidate?.ats.candidate?.talentPool ?? false

  const { updateTalentPoolValue, loading } = useUpdateTalentPool({
    candidateId,
    currentTalentPoolValue: talentPool,
  })

  const onSubmit = async () => {
    await updateTalentPoolValue()

    if (rememberConfirmation) {
      SafeLocalStorage.setItem(LOCAL_STORAGE_KEYS.atsTalentPoolConsentMessage, true)
    }

    onClose()
  }

  return (
    <Modal
      illustration="user-move"
      title={i18n.t('ats.candidate_details.talent_pool_modal.title')}
      description={i18n.t('ats.candidate_details.talent_pool_modal.description')}
      onClose={() => onClose()}
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" flexGrow gap="s4" alignItems="center" justifyContent="flexEnd">
          <Button onClick={onClose} type="secondary">
            {i18n.t('ats.candidate_details.talent_pool_modal.button.discard')}
          </Button>
          <Button submit loading={loading}>
            {i18n.t('ats.candidate_details.talent_pool_modal.button.save')}
          </Button>
        </Box>
      }
    >
      <Box gap="s12">
        <HelpCenterLink name="ats_data_protection_regulations">
          {i18n.t('ats.candidate_details.talent_pool_modal.link')}
        </HelpCenterLink>
        <Box flexDirection="row" gap="s8" alignItems="center">
          <InputCheckBox
            onClick={() => setRememberConfirmation(!rememberConfirmation)}
            checked={rememberConfirmation}
          />
          <Text.Normal>{i18n.t('ats.candidate_details.talent_pool_modal.checkbox')}</Text.Normal>
        </Box>
      </Box>
    </Modal>
  )
}
